export default function RapportsActivitesConfiguration($translatePartialLoaderProvider) {
	$translatePartialLoaderProvider.addPart('rapport.activites');
}

RapportsActivitesConfiguration.$inject = ['$translatePartialLoaderProvider'];
